import { useCallback } from 'react';

import type { ResponseError } from '@rtkwlf/asset-data-service';
import type { QueryFunction, UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { useOrganizationContext } from '@packages/legacy/organization-context';
import { useFeatureFlag } from '@packages/platform/feature-flags/use-feature-flag';

import { useAssetDataServiceApi } from '../use-asset-data-service-api';

const tags = [
  'new tag',
  'tag',
  'a tag',
  'this is a long tag name, please truncate me',
  'one tag',
  'a',
  'b',
  'c',
  'lorem_sql_admin',
  'server',
  'iot',
  'backup_recovery',
  'remote access',
  'internet facing',
  'datastore',
  'iam',
];

export const getTagsQueryKey = (organizationId: string) => [
  organizationId,
  'ads',
  'get-tags',
];

type Options = Omit<
  UseQueryOptions<Set<string>, ResponseError>,
  'queryFn' | 'queryKey'
>;

const mockQueryFn = () =>
  new Promise<Set<string>>((resolve) => {
    setTimeout(() => resolve(new Set(tags)), 500);
  });

export function useTags(options?: Options) {
  const api = useAssetDataServiceApi();
  const { selectedOrganization } = useOrganizationContext();
  const organizationId = selectedOrganization.id;

  const [fullMockedFF] = useFeatureFlag('ADS_FULL_MOCKED');

  const queryFn: QueryFunction<Set<string>> = useCallback(() => {
    if (fullMockedFF) {
      return mockQueryFn();
    }

    return api.getAssetTags({
      organizationId,
    });
  }, [fullMockedFF, api, organizationId]);

  return useQuery({
    queryFn,
    queryKey: getTagsQueryKey(organizationId),
    ...options,
  });
}
